export const SEGMENT_UPLOAD_TYPES = {
  USER: "user",
  FARM: "farm",
  CARBON_PROGRAM: "carbonProgram",
} as const;

export type SegmentUploadType = (typeof SEGMENT_UPLOAD_TYPES)[keyof typeof SEGMENT_UPLOAD_TYPES];

export const SEGMENT_UPLOAD_TYPE_LABELS: Record<SegmentUploadType, string> = {
  [SEGMENT_UPLOAD_TYPES.USER]: "Users",
  [SEGMENT_UPLOAD_TYPES.FARM]: "Farms",
  [SEGMENT_UPLOAD_TYPES.CARBON_PROGRAM]: "Carbon programs",
};

export const SEGMENT_UPLOAD_TYPE_NOUNS: Record<SegmentUploadType, string> = {
  [SEGMENT_UPLOAD_TYPES.USER]: "user",
  [SEGMENT_UPLOAD_TYPES.FARM]: "farm",
  [SEGMENT_UPLOAD_TYPES.CARBON_PROGRAM]: "carbon program",
};

// The few details that identify an entity in the table.
export const SEGMENT_ENTRY_COLUMNS: Record<SegmentUploadType, { key: "name" | "email" | "country" | "slug"; label: string }[]> = {
  [SEGMENT_UPLOAD_TYPES.USER]: [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
  ],
  [SEGMENT_UPLOAD_TYPES.FARM]: [
    { key: "name", label: "Farm" },
    { key: "email", label: "Owner" },
    { key: "country", label: "Country" },
  ],
  [SEGMENT_UPLOAD_TYPES.CARBON_PROGRAM]: [
    { key: "name", label: "Program" },
    { key: "slug", label: "Slug" },
  ],
};

export const SEGMENT_ENTITY_SEARCH_MIN_LENGTH = 2;
export const SEGMENT_ENTITY_SEARCH_DEBOUNCE_MS = 300;
export const SEGMENT_TABLE_PAGE_SIZE = 20;

export const SEGMENT_ENTITY_SEARCH_PLACEHOLDERS: Record<SegmentUploadType, string> = {
  [SEGMENT_UPLOAD_TYPES.USER]: "Search users by name, email or ID",
  [SEGMENT_UPLOAD_TYPES.FARM]: "Search farms by name, owner email or ID",
  [SEGMENT_UPLOAD_TYPES.CARBON_PROGRAM]: "Search programs by name or slug",
};
